import { useEffect } from 'react';
import { useLocation } from 'react-router';

// TODO: extracto a client-specific constant
const stickyHeaderHeight = 140;

export const useGlobalScrollEvents = () => {
  const location = useLocation();
  useEffect(() => {
    const anchorHash = decodeURIComponent(window.location.hash.replace('#', ''));

    if (anchorHash) {
      const targetElement = document.getElementById(anchorHash);
      if (targetElement) {
        const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - stickyHeaderHeight;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth', // Smooth scrolling
        });
      }
    }
  }, [location]);
};
